import { Card } from "ui";

// icons
import PersonRoundedIcon from "@mui/icons-material/PersonRounded"; // users
import FeedRoundedIcon from "@mui/icons-material/FeedRounded"; // posts
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded"; // incidents
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded"; // community

const CountCards = () => {
    return (
        <div className="flex justify-center items-center flex-wrap">
            {/* users */}
            <div className="w-1/2 px-4 py-4">
                <Card
                    className="w-full bg-gradient-custom-orange flex flex-col justify-center items-center gap-2"
                    style={{ height: "142px" }}
                >
                    {/* <div className="bg-momeento-50 rounded w-fit h-fit px-2 py-2"> */}
                    <PersonRoundedIcon className="text-white" />
                    {/* </div> */}
                    <span className="text-white font-medium">Users</span>
                    <span className="text-white  text-sm">30</span>
                </Card>
            </div>
            {/* posts */}
            <div className="w-1/2 px-4 py-4">
                <Card
                    className="w-full bg-gradient-custom-pink flex flex-col justify-center items-center gap-2"
                    style={{ height: "142px" }}
                >
                    {/* <div className="bg-[#44bd32] rounded w-fit h-fit px-2 py-2"> */}
                    <FeedRoundedIcon className="text-white" />
                    {/* </div> */}
                    <span className="text-white font-medium">Posts</span>
                    <span className="text-white text-sm">30</span>
                </Card>
            </div>
            {/* incidents */}
            <div className="w-1/2 px-4 py-4">
                <Card
                    className="w-full bg-gradient-custom-teal flex flex-col justify-center items-center gap-2"
                    style={{ height: "142px" }}
                >
                    {/* <div className="bg-[#dc3545] rounded w-fit h-fit px-2 py-2"> */}
                    <WarningAmberRoundedIcon className="text-white" />
                    {/* </div> */}
                    <span className="text-white font-medium">Incidents</span>
                    <span className="text-white text-sm">30</span>
                </Card>
            </div>
            {/* community */}
            <div className="w-1/2 px-4 py-4">
                <Card
                    className="w-full bg-gradient-custom-indigo flex flex-col justify-center items-center gap-2"
                    style={{ height: "142px" }}
                >
                    {/* <div className="bg-[#8c7ae6] rounded w-fit h-fit px-2 py-2"> */}
                    <PeopleAltRoundedIcon className="text-white" />
                    {/* </div> */}
                    <span className="text-white font-medium">Community</span>
                    <span className="text-white text-sm">30</span>
                </Card>
            </div>
        </div>
    );
};

export default CountCards;
